import React from 'react';
import PropTypes from 'prop-types';
import Base from '../Base';
import MaterialIcon from 'components/common/MaterialIcon';
import { Input } from 'antd';

@autobind
/**
 *
 */
export default class WebSite extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    return (
      <Input
        type="url"
        prefix={<MaterialIcon name="web" />}
        onChange={(event) => this.props.onChange(app.transform.fa2en(event.target.value))}
      />
    );
  }
}
